import { useLayoutEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import routes from '@/common/routes/routes';
import Seo from './common/components/Seo';
import { setupUtms } from './common/functions/setupUtms';

function App() {
	const location = useLocation();

	useLayoutEffect(() => {
		setupUtms(new URLSearchParams(location.search));
	}, [location.search]);

	return (
		<>
			<Routes>
				{routes.map((route) => (
					<Route
						key={route.path}
						path={route.path}
						element={
							<>
								<Seo />
								{route.element}
							</>
						}
					/>
				))}
				<Route path='*' element={<Navigate to='/' replace />} />
			</Routes>
		</>
	);
}

export default App;
